const testimonials = [
  { q: 'CargoNet olmadan Amazon mağazamızı bu kadar hızlı büyütemezdik. Fulfillment süreci son derece profesyonel.', name: 'Ahmet Kaya', role: 'CEO, TeknoShop', tag: 'E-Ticaret', img: 'https://readdy.ai/api/search-image?query=professional%20Turkish%20male%20executive%20headshot%20dark%20background%20studio%20lighting%20confident%20smile%20business%20suit&width=80&height=80&seq=tv2-1&orientation=squarish' },
  { q: 'Gümrük işlemlerini tamamen devrettik. Artık ihracata odaklanabiliyoruz. Mükemmel iş ortağı.', name: 'Zeynep Demir', role: 'Direktör, ModaEvim', tag: 'Mikro İhracat', img: 'https://readdy.ai/api/search-image?query=professional%20Turkish%20female%20manager%20dark%20studio%20headshot%20business%20casual%20warm%20expression%20confident&width=80&height=80&seq=tv2-2&orientation=squarish' },
  { q: 'On Board Kurye ile kritik belgemiz tam zamanında ulaştı. Gerçekten hayat kurtardılar.', name: 'Murat Şahin', role: 'Kurucu, TekPart', tag: 'On Board', img: 'https://readdy.ai/api/search-image?query=young%20Turkish%20entrepreneur%20male%20portrait%20dark%20background%20studio%20casual%20business%20attire%20friendly%20expression&width=80&height=80&seq=tv2-3&orientation=squarish' },
  { q: 'Zamanında teslimat oranları inanılmaz. Son 6 ayda sadece iki gecikmeli kargo. Bu sektörde büyük başarı.', name: 'Elif Arslan', role: 'E-Ticaret Direktörü', tag: 'Ekspres Kurye', img: 'https://readdy.ai/api/search-image?query=professional%20Turkish%20female%20director%20dark%20background%20corporate%20headshot%20warm%20smile%20business%20attire&width=80&height=80&seq=tv2-4&orientation=squarish' },
  { q: 'Anlık takip sistemi müşterilerimizin güvenini artırdı. Bu özellik rakiplerimizden çok öne geçirdi.', name: 'Serkan Öztürk', role: 'Genel Müdür, TekPart', tag: 'GPS Takip', img: 'https://readdy.ai/api/search-image?query=senior%20Turkish%20business%20executive%20male%20dark%20studio%20background%20professional%20headshot%20confident&width=80&height=80&seq=tv2-5&orientation=squarish' },
  { q: 'Fulfillment depo hizmetleri sayesinde kendi depomuzdan tamamen kurtulduk. Maliyet tasarrufu muazzam.', name: 'Canan Yıldız', role: 'Operasyon Yöneticisi', tag: 'Fulfillment', img: 'https://readdy.ai/api/search-image?query=Turkish%20businesswoman%20operations%20manager%20dark%20background%20professional%20headshot%20warm%20smile%20modern%20office&width=80&height=80&seq=tv2-6&orientation=squarish' },
];

export default function TestimonialsSection() {
  return (
    <section
      className="relative overflow-hidden"
      style={{ background: 'var(--bg2)', padding: '100px 0', borderTop: '1px solid var(--border)' }}
    >
      <div className="absolute pointer-events-none" style={{ top: '40%', left: '50%', transform: 'translateX(-50%)', width: 800, height: 400, background: 'radial-gradient(ellipse, rgba(232,97,26,0.05) 0%, transparent 65%)', borderRadius: '50%' }}></div>

      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-xl mx-auto mb-14">
          <div className="label inline-flex"><div className="label-dot"></div>Müşteri Deneyimleri</div>
          <h2
            className="reveal h-font"
            style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 'clamp(36px, 4.5vw, 56px)', color: 'var(--text1)', lineHeight: 1.1 }}
          >
            Onlar anlatsın,<br /><span className="text-gradient">siz karar verin.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {testimonials.map((t, i) => (
            <div key={i} className={`reveal d${Math.min(i + 1, 6)} card-dark p-6 flex flex-col`}>
              <div className="flex items-center justify-between mb-4">
                <span className="tag-sm">{t.tag}</span>
                <div className="flex gap-0.5">
                  {[...Array(5)].map((_, s) => (
                    <i key={s} className="ri-star-fill text-[#E8611A]" style={{ fontSize: 12 }}></i>
                  ))}
                </div>
              </div>

              <p className="flex-1 text-sm leading-relaxed mb-6" style={{ color: 'var(--text2)', lineHeight: 1.75 }}>
                &ldquo;{t.q}&rdquo;
              </p>

              <div className="flex items-center gap-3 pt-4" style={{ borderTop: '1px solid var(--border)' }}>
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0" style={{ border: '1px solid rgba(232,97,26,0.3)' }}>
                  <img src={t.img} alt={t.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 14, color: 'var(--text1)' }}>{t.name}</div>
                  <div style={{ fontSize: 12, color: 'var(--text3)' }}>{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
